// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.plaid-container {
  padding: 0px;
}
.plaid-container .intro-text {
  font-size: 12px;
  margin-bottom: 0px;
}
.plaid-container .select-bank-text {
  font-size: 12px;
}
.plaid-container .asset-mix-input-outer {
  padding-bottom: 15px;
  margin-bottom: 10px;
}
.plaid-container .asset-mix-input {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  column-gap: 30px;
  margin-bottom: 15px;
}
.plaid-container .bank-list-container {
  overflow: auto;
  margin-top: 20px;
  min-height: 250px;
}
.plaid-container .bank-list-container .MuiFormGroup-root {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
}
.plaid-container .inv-list-container {
  overflow: auto;
  margin-top: 20px;
}
.plaid-container .inv-list-container .MuiFormGroup-root {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
}
.plaid-container .banks-list {
  list-style: none;
}
.plaid-container .banks-list-item {
  border-bottom: 1px solid white;
  padding: 8px;
  font-size: 12px;
  cursor: pointer;
}
.plaid-container .banks-list-item p {
  font-size: 10px;
  margin-left: 30px;
  color: gray;
}
.plaid-container .user-credentials-form {
  margin-top: 0px;
}
.plaid-container .user-credentials-form .enter-cred-text {
  font-size: 12px;
  font-weight: bold;
}
.plaid-container .user-credentials-form .terms-cond-text {
  font-size: 10px;
}
.plaid-container .search-container {
  float: right;
}
.plaid-container .search-container .MuiTextField-root input::placeholder {
  font-size: 10px;
}
.plaid-container .search-container .MuiTextField-root .MuiOutlinedInput-root {
  border: 1px solid #00a19a !important;
  box-sizing: border-box;
  border-radius: 13px;
}
.plaid-container .search-container .MuiTextField-root {
  background: linear-gradient(180deg, #ffffff 0%, rgba(255, 255, 255, 0) 357.5%);
  border: 1px solid #ffffff;
  box-sizing: border-box;
  border-radius: 13px;
}
.plaid-container .search-container .MuiInputBase-input {
  padding: 8px 0;
}
.plaid-container .acc-list-container .acc-list-items {
  max-height: 200px;
  overflow: auto;
}`, "",{"version":3,"sources":["webpack://./src/styles/plaiduiV3.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;AACF;AACE;EACE,eAAA;EACA,kBAAA;AACJ;AAEE;EACE,eAAA;AAAJ;AAEE;EACE,oBAAA;EACA,mBAAA;AAAJ;AAEE;EACE,aAAA;EACA,qCAAA;EACA,gBAAA;EACA,mBAAA;AAAJ;AAGE;EAEE,cAAA;EACA,gBAAA;EACA,iBAAA;AAFJ;AAII;EACE,aAAA;EACA,qCAAA;AAFN;AAME;EACE,cAAA;EACA,gBAAA;AAJJ;AAMI;EACE,aAAA;EACA,qCAAA;AAJN;AAQE;EACE,gBAAA;AANJ;AAQI;EACE,8BAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;AANN;AAQM;EACE,eAAA;EACA,iBAAA;EACA,WAAA;AANR;AAWE;EACE,eAAA;AATJ;AAWI;EACE,eAAA;EACA,iBAAA;AATN;AAYI;EACE,eAAA;AAVN;AAcE;EACE,YAAA;AAZJ;AAeM;EACE,eAAA;AAbR;AAgBM;EACE,oCAAA;EACA,sBAAA;EACA,mBAAA;AAdR;AAkBI;EAEE,8EAAA;EAGA,yBAAA;EACA,sBAAA;EACA,mBAAA;AAnBN;AAsBI;EACE,cAAA;AApBN;AA2BI;EACE,iBAAA;EACA,cAAA;AAzBN","sourcesContent":[".plaid-container {\r\n  padding: 0px;\r\n\r\n  .intro-text {\r\n    font-size: 12px;\r\n    margin-bottom: 0px;\r\n  }\r\n\r\n  .select-bank-text {\r\n    font-size: 12px;\r\n  }\r\n  .asset-mix-input-outer {\r\n    padding-bottom: 15px;\r\n    margin-bottom: 10px;\r\n  }\r\n  .asset-mix-input {\r\n    display: grid;\r\n    grid-template-columns: repeat(2, 1fr);\r\n    column-gap: 30px;\r\n    margin-bottom: 15px;\r\n  }\r\n\r\n  .bank-list-container {\r\n    // height: 230px;\r\n    overflow: auto;\r\n    margin-top: 20px;\r\n    min-height: 250px;\r\n\r\n    .MuiFormGroup-root {\r\n      display: grid;\r\n      grid-template-columns: repeat(3, 1fr);\r\n    }\r\n  }\r\n\r\n  .inv-list-container {\r\n    overflow: auto;\r\n    margin-top: 20px;\r\n\r\n    .MuiFormGroup-root {\r\n      display: grid;\r\n      grid-template-columns: repeat(3, 1fr);\r\n    }\r\n  }\r\n\r\n  .banks-list {\r\n    list-style: none;\r\n\r\n    &-item {\r\n      border-bottom: 1px solid #ffff;\r\n      padding: 8px;\r\n      font-size: 12px;\r\n      cursor: pointer;\r\n\r\n      p {\r\n        font-size: 10px;\r\n        margin-left: 30px;\r\n        color: gray;\r\n      }\r\n    }\r\n  }\r\n\r\n  .user-credentials-form {\r\n    margin-top: 0px;\r\n\r\n    .enter-cred-text {\r\n      font-size: 12px;\r\n      font-weight: bold;\r\n    }\r\n\r\n    .terms-cond-text {\r\n      font-size: 10px;\r\n    }\r\n  }\r\n\r\n  .search-container {\r\n    float: right;\r\n\r\n    .MuiTextField-root {\r\n      input::placeholder {\r\n        font-size: 10px;\r\n      }\r\n\r\n      .MuiOutlinedInput-root {\r\n        border: 1px solid #00a19a !important;\r\n        box-sizing: border-box;\r\n        border-radius: 13px;\r\n      }\r\n    }\r\n\r\n    .MuiTextField-root {\r\n      // width: 100%;\r\n      background: linear-gradient(180deg,\r\n          #ffffff 0%,\r\n          rgba(255, 255, 255, 0) 357.5%);\r\n      border: 1px solid #ffffff;\r\n      box-sizing: border-box;\r\n      border-radius: 13px;\r\n    }\r\n\r\n    .MuiInputBase-input {\r\n      padding: 8px 0;\r\n    }\r\n  }\r\n\r\n  .financial-instn-container {}\r\n\r\n  .acc-list-container {\r\n    .acc-list-items {\r\n      max-height: 200px;\r\n      overflow: auto;\r\n    }\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
